<template>
  <v-app>

    <Navigation app v-if="showNav&&routeName!=='PublicJobDetails'" :route-name="routeName" @mode-switch="setOverlay($event)"></Navigation>

    <v-main :class="`${routeName==='ObrJobDetails'||routeName==='HefeJobDetails'||routeName==='PublicJobDetails'?'pb-0':''}`" :style="` ${$vuetify.theme.dark?'':'background-color:rgb(230,230,230)'}`">

      <!-- <keep-alive max="2"> -->
      <!-- This is the key, to update the view when the route path or language changes -->
      <router-view :key="$route.path + language" />
      <!-- </keep-alive> -->

    </v-main>
    <BottomNavigation v-if="showNav&&routeName!=='ObrJobDetails'&&routeName!=='HefeJobDetails'&&routeName!=='PublicJobDetails'&&!$vuetify.breakpoint.mdAndUp" :routeName="routeName"></BottomNavigation>

    <v-dialog v-model="status.loading.splash" scrollable fullscreen persistent :overlay="false" max-width="500px" transition="dialog-transition">
      <v-card class="grey darken-4" tile>
        <v-layout fill-height column justify-center align-center class="grey darken-4">
          <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-overlay v-model="modeOverlay" z-index="4" opacity="0.8"></v-overlay>
    <chat-container>
    </chat-container>
    <time-container>
    </time-container>

  </v-app>
</template>

<script>
import {
  mapState
} from 'vuex'
import Navigation from '@/components/common/Navigation.vue'
import BottomNavigation from '@/components/common/BottomNavigation.vue'
import ChatContainer from '@/components/common/chat/ChatContainer.vue'
import TimeContainer from '@/components/obrero/timekeeping/TimeContainer.vue'

export default {
  components: {
    Navigation,
    BottomNavigation,
    ChatContainer,
    TimeContainer
  },
  data () {
    return {
      newVersionAvailable: false,
      app_background: {
        'background-image': `url(${require('@/assets/topography.svg')})`,
        'background-position': 'center center',
        'background-repeat': 'repeat scroll',
        'background-size': 'cover'
      },
      open: false,
      modeOverlay: false
    }
  },
  mounted () {
    if (localStorage.version !== undefined) {
      if (localStorage.version !== this.version) {
        localStorage.version = this.version
        // window.location.reload(true)
        this.forceSWupdate()
      }
    } else {
      localStorage.version = this.version
      // window.location.reload(true)
      this.forceSWupdate()
    }
    // setTimeout(() => {
    //   this.hi = false
    // }, 100)
  },
  methods: {
    setOverlay (event) {
      this.modeOverlay = event
    },
    forceSWupdate () {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          for (let registration of registrations) {
            registration.update()
          }
        })
      }
    }
  },
  computed: {
    ...mapState(['currentUser', 'userProfile', 'status', 'language', 'version', 'chatOpen']),
    routeName () {
      return this._routerRoot._route.name
    },
    // compoundProperty() {
    //   return [this.$route, this.currentUser, this.userProfile].join()
    // },
    showNav () {
      if (this.userProfile.firstEntry !== undefined) {
        return !this.userProfile.firstEntry
      } else {
        return false
      }
    }
  },
  watch: {

    'status.loading.splash': {
      handler: function () {

      },
      immediate: true
    }
  },
  name: 'App'
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
